import store from "@/store";
import {userSuccess} from "@/actions";
import moment from "moment";
import api from "./configuration";
import apiUrl from "./url";

const USE_AUTH_INTERCEPTOR = true;

export const SeasonAPI = {
	create: async (data) =>
		(
			await api.request({
				method: "POST",
				url: apiUrl + "/Seasons",
				data,
				useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			})
		).data,
	update: async (id, data) =>
		(
			await api.request({
				method: "PUT",
				url: apiUrl + "/Seasons/" + id,
				data,
				useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			})
		).data,
	delete: async (id) =>
		api.request({
			method: "DELETE",
			url: apiUrl + "/Seasons/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		}),
	current: async () => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/CurrentSeason",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	allSeasons: async () => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/AllSeasons",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	getById: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Seasons/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
};

export const refreshSeasons = async () => {
	const seasons = (await SeasonAPI.allSeasons()) || [];
	seasons.sort((a, b) => new Date(b.startDate) - new Date(a.startDate));
	const {user, season: selected} = store.getState();
	const today = moment().format("YYYY-MM-DD");
	const current = seasons.find(
		(season) =>
			today >= season.startDate.slice(0, 10) &&
			today <= season.endDate.slice(0, 10),
	);
	store.dispatch(
		userSuccess({
			user,
			seasons,
			season:
				seasons.find((season) => season.id === selected?.id) ||
				current ||
				seasons[0] ||
				null,
		}),
	);
	return seasons;
};
